import { type FC, type MouseEvent } from "react";

import { Checkbox } from "mds/components/Checkbox";
import { ListItem } from "mds/components/ListItem";
import { FolderIcon } from "mds/icons";
import { CourseWithGroupingType } from "store/selectors/types";

type CourseSelectionListProps = {
  courseCodes: CourseWithGroupingType[];
  selectedCourseCodeIds: string[];
  onCourseCodeToggle: (courseCodeId: string) => void;
};

export const CourseCodeSelectionList: FC<CourseSelectionListProps> = ({
  courseCodes,
  selectedCourseCodeIds,
  onCourseCodeToggle,
}) => {
  const handleCourseCodeSelected = (event: MouseEvent, courseCodeId: string) => {
    event.preventDefault();
    event.stopPropagation();
    onCourseCodeToggle(courseCodeId);
  };

  if (courseCodes.length === 0) {
    return null;
  }

  return (
    <div className="max-h-[150px] overflow-y-scroll rounded-lg border border-black-tint-90 p-2">
      {courseCodes.map((courseCode) => (
        <div key={courseCode.id}>
          <ListItem className="w-full gap-2">
            <Checkbox
              checked={selectedCourseCodeIds.includes(courseCode.id)}
              className="w-full"
              onContainerClick={(e) => handleCourseCodeSelected(e, courseCode.id)}
            >
              <span className="flex w-full items-center justify-between">
                <span>{courseCode.title}</span>

                {courseCode.groupingTitle && (
                  <span className="flex items-center gap-1">
                    <FolderIcon className="size-4 text-black-tint-70" />
                    <span className="text-black-tint-70">{courseCode.groupingTitle}</span>
                  </span>
                )}
              </span>
            </Checkbox>
          </ListItem>
        </div>
      ))}
    </div>
  );
};
